import React from 'react';

const Dashboard = () => {
  return (
    <div className="dashboard">
      <h1>Welcome to CBREX Admin</h1>
      <p>Select an option from the sidebar to get started.</p>
    </div>
  );
};

export default Dashboard;
